export default __webpack_public_path__ + "static/media/6.4c7646b0.jpg";